import request from '../request.js'

// 查询权限
const selectAll = function (data) {
    return request({
        url: 'sysLimit/selectAll',
        method: 'post',
        data
    })
}

// 添加或者更新权限
const saveOrUpdate = function (data) {
    return request({
        url: 'sysLimit/saveOrUpdate',
        method: 'post',
        data
    })
}

// 根据限定ID 删除
const deleteById = function (data) {
    return request({
        url: 'sysLimit/deleteById',
        method: 'post',
        data
    })
}

// 查询角色列表和菜单列表(渲染使用)
const getRoleAndMenuList = function (data) {
    return request({
        url: 'sysLimitRoleMenuBtn/getRoleAndMenuList',
        method: 'post',
        data
    })
}

// 根据限定ID 查询已勾选状态列表
const getRolesByLimitId = function (data) {
    return request({
        url: 'sysLimitRoleMenuBtn/getRolesByLimitId',
        method: 'post',
        data
    })
}

// 角色保存按钮
const roleInsert = function (data) {
    return request({
        url: 'sysLimitRole/insert',
        method: 'post',
        data
    })
}

// 菜单保存按钮
const menuInsert = function (data) {
    return request({
        url: 'sysLimitRoleMenu/insert',
        method: 'post',
        data
    })
}

// 按钮列表保存
const btnInsert = function (data) {
    return request({
        url: 'sysLimitRoleMenuBtn/saveOrUpdate',
        method: 'post',
        data
    })
}

// 主体菜单范围管理 - 新增/修改 主体
const saveOrUpdateRange = function (data) {
    return request({
        url: 'sysLimit/saveOrUpdateRange',
        method: 'post',
        data
    })
}

// 主体菜单范围管理 - 新增/修改 主体
const deleteByIdRange = function (data) {
    return request({
        url: 'sysLimit/deleteByIdRange',
        method: 'post',
        data
    })
}

// 主体菜单范围管理 - 根据id，获取信息
const getObjectById = function (data) {
    return request({
        url: 'sysLimit/getObjectById',
        method: 'post',
        data
    })
}

export {
    selectAll, saveOrUpdate, deleteById, getRoleAndMenuList, getRolesByLimitId, roleInsert,
    menuInsert, btnInsert, saveOrUpdateRange, deleteByIdRange, getObjectById
}